<template>
    <OnsiteAuditRequestView 
		:preview="preview" 
		:previewID="previewID == 0 ? parseInt(this.$route.params.id) : previewID"
		:submitterName="submitterName"
	></OnsiteAuditRequestView>
</template>

<script>
import OnsiteAuditRequestView from "./OnsiteAuditRequestView.vue"
export default {
	name: "OnsiteTemplatePreview",
	components: {
		OnsiteAuditRequestView
	},
	props: {
		preview: {
			type: Boolean,
			default: true,
		},
		previewID: {
			type: Number,
			default: 0,
		},
		submitterName: {
			type: String,
			default: null
		}
	},
}
</script>